import translationEN from './en/translation.json';
import translationIT from './it/translation.json';
const it = {
  translation: translationIT
};
const en = {
  translation: translationEN
};
export { it, en };